// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import {
  Button,
  Icon,
  Image,
  OsModal,
  OsStack,
  Theme,
  Typography,
} from "@outschool/backpack";
import { faSparkles, faTrash } from "@outschool/icons";
import React from "react";

export type ModalMixTopic = {
  uid?: string;
  title: string;
  description: string;
  imageUrl: string;
  isDefault: boolean;
};

interface MixTopicModalProps {
  topic: ModalMixTopic | null;
  onClose: () => void;
}

export default function MixTopicModal({ topic, onClose }: MixTopicModalProps) {
  let actionPrimary;
  if (topic?.isDefault) {
    actionPrimary = <Button onClick={onClose}>Close</Button>;
  } else if (topic?.uid) {
    // TODO: async call for remove
    actionPrimary = (
      <Button onClick={() => {}} startIcon={<Icon icon={faTrash} />}>
        Remove
      </Button>
    );
  } else {
    // TODO: async call for save
    actionPrimary = (
      <Button onClick={() => {}} startIcon={<Icon icon={faSparkles} />}>
        Save This Mix
      </Button>
    );
  }

  let actionSecondary;
  if (!topic?.isDefault) {
    actionSecondary = <Button onClick={onClose}>Close</Button>;
  }

  return (
    <OsModal
      open={!!topic}
      onClose={onClose}
      title={topic?.title}
      actionPrimary={actionPrimary}
      actionSecondary={actionSecondary}
    >
      <OsStack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="flex-start"
      >
        <Image
          src={topic?.imageUrl}
          alt={topic?.title}
          sx={(theme: Theme) => ({
            objectFit: "cover",
            borderRadius: "0.5em",
            width: "100%",
            aspectRatio: "1.5",
            [theme.breakpoints.up("sm")]: {
              width: 180,
            },
          })}
        />
        <Typography variant="body1">{topic?.description}</Typography>
      </OsStack>
    </OsModal>
  );
}
